import { Logger } from './logger';

const getTranslationsStore = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  if (!window.TRANSLATIONS || typeof window.TRANSLATIONS !== 'object') {
    window.TRANSLATIONS = {};
  }
  return window.TRANSLATIONS;
};

class _Translations {
  constructor() {
    this._splideI18nCache = null;
  }

  /**
   * Restituisce una label tradotta a partire dalla chiave, sostituendo eventuali
   * placeholder nel formato "Testo prima {nome} testo dopo" con i valori passati in `params`. Se la
   * chiave non esiste usa `fallback` (se fornito) o la chiave stessa.
   *
   * Nell'head della pagina deve esserci la variabile TRANSLATIONS con le traduzioni.
   *
   * <script>
   *  window.TRANSLATIONS = window.TRANSLATIONS || {};
   *  Object.assign(window.TRANSLATIONS, {
   *    NOTIZIE_FILTERS_TRIGGER_EMPTY: 'Scegli tra le categorie',
   *    NOTIZIE_FILTERS_TRIGGER_SELECTED: '{count} Selezionati',
   *    ...
   *  });
   * </script>
   *
   * @param {String} key chiave della traduzione (es. "MEDIA_WRAPPER_PLAY_VIDEO")
   * @param {Object} [params={}] mappa dei parametri da interpolare nella stringa
   * @param {String} [fallback] testo di fallback se la chiave non è definita
   * @returns {String} la stringa tradotta e interpolata
   *
   * @example
   * Translations.getLabel('NOTIZIE_FILTERS_TRIGGER_SELECTED', { count: 3 }, '3 Selezionati');
   */
  getLabel(key, params = {}, fallback) {
    const translations = getTranslationsStore();
    let template = translations[key];

    if (typeof template !== 'string') {
      Logger.warn(`Traduzione non trovata per la chiave "${key}"`);
      template = typeof fallback === 'string' ? fallback : key;
    }

    if (!params || typeof params !== 'object') {
      return template;
    }

    return template.replace(/\{(\w+)\}/g, (match, paramName) => {
      if (Object.prototype.hasOwnProperty.call(params, paramName)) {
        return params[paramName];
      }
      return match;
    });
  }

  /**
   * Restituisce un oggetto con tutte le traduzioni destinate a Splide,
   * ovvero le chiavi che iniziano con "SPLIDE_I18N_". La parte di chiave
   * successiva al prefisso viene usata come nome della proprietà
   * da passare all'opzione `i18n` di Splide.
   *
   * Esempio:
   *  window.TRANSLATIONS = {
   *    SPLIDE_I18N_prev: 'Slide precedente',
   *    SPLIDE_I18N_next: 'Slide successiva',
   *  };
   *
   *  const i18n = Translations.getSplideI18n();
   *  // i18n = { prev: 'Slide precedente', next: 'Slide successiva' }
   *
   * @returns {Object} mappa chiave-valore per l'opzione i18n di Splide
   */
  getSplideI18n() {
    if (this._splideI18nCache) {
      return this._splideI18nCache;
    }

    const translations = getTranslationsStore();
    const prefix = 'SPLIDE_I18N_';
    const i18n = {};

    Object.keys(translations).forEach((key) => {
      if (!key.startsWith(prefix)) {
        return;
      }

      const optionKey = key.slice(prefix.length);

      if (optionKey) {
        i18n[optionKey] = translations[key];
      }
    });

    if (Object.keys(i18n).length === 0) {
      Logger.warn('Nessuna traduzione trovata per le chiavi Splide (SPLIDE_I18N_*)');
    }

    this._splideI18nCache = i18n;

    return i18n;
  }
}

export const Translations = new _Translations();
